<cam-badge [value]="this.getTranslate()"></cam-badge>
